import { render, staticRenderFns } from "./svgBazar.vue?vue&type=template&id=0988f51a"
import script from "./svgBazar.vue?vue&type=script&lang=js"
export * from "./svgBazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports